import { Dispatch } from 'redux'

import { activateLicenseError } from '@/stores/slices/licenseErrorSlice'
import { clearLicenseInfo } from '@/utils/license'
import { LicenseErrorSource, toLicenseErrorPayload } from '@/utils/licenseError'

interface HandleLicenseErrorParams {
  error: unknown
  source: LicenseErrorSource
  dispatch: Dispatch
}

export const handleLicenseError = ({
  error,
  source,
  dispatch,
}: HandleLicenseErrorParams): boolean => {
  const payload = toLicenseErrorPayload(error, source)

  if (!payload) {
    return false
  }

  clearLicenseInfo()
  dispatch(activateLicenseError(payload))

  return true
}
